import { Injectable }    from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { Observable } from 'rxjs';

import 'rxjs/add/operator/toPromise';

import * as ent from '../entities/index'
import * as filters from '../filters/index'
import * as serv from '../services/index'

@Injectable()
export class EquipmentService {

    private baseEquipmentUrl = "/Equipment";  // URL to web api
    private getEquipmentsURL = '';
    private convertEquipmentRequestsURL = '';

  
    appConfig: ent.AppConfig;

    constructor(private httpClient: HttpClient, private configService: serv.ConfigService) {
        this.baseEquipmentUrl = this.configService.appConfig.UrlBase + this.baseEquipmentUrl;

        this.getEquipmentsURL = this.baseEquipmentUrl + '/GetEquipments';
        this.convertEquipmentRequestsURL = this.baseEquipmentUrl + '/ConvertEquipmentRequests';
    }

    getEquipments(filter: filters.EquipmentFilter): Observable<ent.Equipment[]> {
        return this.httpClient.post<ent.Equipment[]>(this.getEquipmentsURL, filter);
    }

    convertEquipmentRequests(): Observable<ent.Response> {
        return this.httpClient.get<ent.Response>(this.convertEquipmentRequestsURL);
    }

}
